import { useModalStore } from "@/stores/modals/modals.store";

/**
 * Opening the start-project dialog, in one place.
 *
 * Four entry points offer "create a project" — the New Project button, the project switcher's row,
 * and the two empty states on the project list — and they must present the same dialog, at the same
 * width, announced under the same title. Keeping the `modals.open` call here is what stops the four
 * from drifting apart. Same reasoning as `useCloneProjectStateModal`.
 *
 * Three of them used to be `<RouterLink to="/create-project">`, which is why this exists now: the
 * create wizard's route is gone, so an entry point is a dialog rather than a destination, and a link
 * cannot open one.
 */

/** What screen readers announce for the dialog. */
export const START_PROJECT_MODAL_TITLE = "Start a new project";

export function useStartProjectModal() {
  const modals = useModalStore();

  const openStartProjectModal = async () => {
    // 640: four fields don't need more, and at 880 the dialog read as a page. The name/calculation
    // row stays two columns regardless — its sm: split keys on the VIEWPORT, not the dialog — so
    // narrowing costs no rows, only line length.
    await modals.open("StartProjectModal", undefined, {
      wrapperClass: "max-w-[640px]! min-h-0!",
      ariaLabel: START_PROJECT_MODAL_TITLE,
    });
  };

  return { openStartProjectModal };
}

export default useStartProjectModal;
